<div class="card m-3"> 
  <div class="card-body">
  <h2>Add Material</h2>
  <div class="card-body"><form (ngSubmit)="saveMaterial()" id="formMaterial">
    <label>Product Name:</label><br>
    <!-- <input type="number" [(ngModel)]="material.MaterialsID" name="MaterialsID" required /> -->
    <input type="text" [(ngModel)]="material.productName" title="ProductName" name="ProductName" required /><br><br>
 
<label>Product Description:</label><br>
<input type="text" [(ngModel)]="material.productDescription" title="productDescription" name="productDescription" required />  
<br>  <br>
  
<label>Product Category:</label><br>
<input type="text" [(ngModel)]="material.productCategory" title="productCategory" name="productCategory" required />  
<br>  <br>

<label>Sub Category:</label><br>
<input type="text" [(ngModel)]="material.subCategory" title="subCategory" name="subCategory" required />  
<br>  <br>


    <label>Price:</label><br>
    <input type="text" [(ngModel)]="material.productPrice" title="productPrice" name="productPrice" required />  
  <br>  <br>
    <!-- Add more input fields for other properties -->
  
    <button type="submit">Save</button>
  </form>
  </div></div>